import { render, staticRenderFns } from "./_highlight.vue?vue&type=template&id=cede6842&lang=pug&"
import script from "./_highlight.vue?vue&type=script&lang=js&"
export * from "./_highlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports